import React from 'react';
import useLanguage from '../../hooks/useLanguage';
import companyData from '../../data/company.json';
import translationsData from '../../data/translations.json';
import { FiEye, FiTarget } from 'react-icons/fi';

/**
 * VisionMission Component
 * Displays company vision and mission statements
 */
const VisionMission = () => {
  const { language } = useLanguage();

  const visionTitle = language === 'ko' ? translationsData.titles.vision : translationsData.titles.visionEn;
  const missionTitle = language === 'ko' ? translationsData.titles.mission : translationsData.titles.missionEn;
  const vision = language === 'ko' ? companyData.vision : companyData.visionEn;
  const mission = language === 'ko' ? companyData.mission : companyData.missionEn;

  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-blue-600 via-blue-700 to-blue-800 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Vision */}
          <div className="flex flex-col items-center text-center lg:items-start lg:text-left">
            <div className="flex items-center justify-center w-16 h-16 bg-white bg-opacity-20 rounded-full mb-6">
              <FiEye className="w-8 h-8 text-white" />
            </div>
            <h2 className="text-2xl md:text-3xl font-bold mb-4">{visionTitle}</h2>
            <p className="text-xl text-blue-100 leading-relaxed">
              {vision}
            </p>
          </div>

          {/* Mission */}
          <div className="flex flex-col items-center text-center lg:items-start lg:text-left">
            <div className="flex items-center justify-center w-16 h-16 bg-white bg-opacity-20 rounded-full mb-6">
              <FiTarget className="w-8 h-8 text-white" />
            </div>
            <h2 className="text-2xl md:text-3xl font-bold mb-4">{missionTitle}</h2>
            <p className="text-xl text-blue-100 leading-relaxed">
              {mission}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionMission;
